// src/components/tableros/tabs/EventosTab.js
import React from 'react';
import {
  Grid,
  Paper,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Divider,
  Button
} from '@mui/material';
import {
  DirectionsRun as TrackIcon,
  SettingsEthernet as HorizontalFieldIcon,
  Height as VerticalFieldIcon,
  OpenInNew as OpenInNewIcon
} from '@mui/icons-material';

const EventosTab = ({
  boardType,
  setBoardType,
  openCurrentTablero
}) => {
  // Información de cada tipo de tablero
  const boardTypes = [
    {
      id: 'track',
      name: 'Pista',
      icon: <TrackIcon fontSize="large" />,
      description: 'Para carreras de atletismo, ciclismo y otros eventos de pista.'
    },
    {
      id: 'horizontalField',
      name: 'Campo Horizontal',
      icon: <HorizontalFieldIcon fontSize="large" />,
      description: 'Para eventos de campo con progresión horizontal como salto largo y lanzamientos.'
    },
    {
      id: 'verticalField',
      name: 'Campo Vertical',
      icon: <VerticalFieldIcon fontSize="large" />,
      description: 'Para eventos de campo con progresión vertical como salto alto y pértiga.'
    }
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Tipo de Tablero
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Selecciona el tipo de tablero según la disciplina deportiva que deseas mostrar. Cada tipo está optimizado para diferentes tipos de competición.
          </Typography>

          {/* Selector de tipo de tablero */}
          <Grid container spacing={3} sx={{ mt: 1 }}>
            {boardTypes.map((type) => (
              <Grid item xs={12} md={4} key={type.id}>
                <Paper 
                  variant="outlined" 
                  sx={{ 
                    p: 2, 
                    border: type.id === boardType ? '2px solid' : '1px solid',
                    borderColor: type.id === boardType ? 'primary.main' : 'divider',
                    backgroundColor: type.id === boardType ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                    cursor: 'pointer'
                  }}
                  onClick={() => setBoardType(type.id)}
                >
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mb: 1,
                    color: type.id === boardType ? 'primary.main' : 'inherit'
                  }}>
                    {type.icon}
                    <Typography variant="h6" sx={{ ml: 1, fontWeight: type.id === boardType ? 'bold' : 'normal' }}>
                      {type.name}
                    </Typography>
                  </Box>
                  
                  <Typography variant="body2" color="text.secondary">
                    {type.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>

          <Divider sx={{ my: 3 }} />
          
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<OpenInNewIcon />}
              onClick={openCurrentTablero}
              size="large"
            >
              Abrir Tablero de {boardTypes.find(t => t.id === boardType)?.name || 'Resultados'}
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default EventosTab;